import { render, staticRenderFns } from "./article5.vue?vue&type=template&id=4e8e7fb2&scoped=true"
import script from "./article5.vue?vue&type=script&lang=js"
export * from "./article5.vue?vue&type=script&lang=js"
import style0 from "./article5.vue?vue&type=style&index=0&id=4e8e7fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8e7fb2",
  null
  
)

export default component.exports